




















import { filterPresenterMixin } from './common';
import ZenSearch from '../../../ZenSearch.vue';

export default {
  name: 'DecimalNumberFilterAttributePresenter',
  components: {
    ZenSearch,
  },
  props: {
    ...filterPresenterMixin.props,
  },
  methods: {
    update(value: string): void {
      this.$emit('input', value);
    },
  },
};
